import { DATABRICKS_CERTIFICATION_RESOURCE_PREFIX } from "./certification-sweeper.js";

/** Build a collision-resistant authoring-certification name without dropping the unique suffix. */
export function databricksCertificationResourceName(
  component: string,
  suffix: string,
  maxLength = 63,
): string {
  const normalized = component
    .toLowerCase()
    .replace(/[^a-z0-9_-]+/g, "-")
    .replace(/^-+|-+$/g, "");
  const budget = maxLength - DATABRICKS_CERTIFICATION_RESOURCE_PREFIX.length - suffix.length;
  if (budget < 0) {
    throw new Error(
      `Databricks certification resource limit ${maxLength} is too short for the reserved prefix and suffix.`,
    );
  }
  if (budget <= 1) return `${DATABRICKS_CERTIFICATION_RESOURCE_PREFIX}${suffix}`;
  const bounded = (normalized || "resource").slice(0, budget - 1);
  return `${DATABRICKS_CERTIFICATION_RESOURCE_PREFIX}${bounded}-${suffix}`;
}
